<template>
  <v-autocomplete
    :component-item="component"
    :items="visibleStations"
    v-model="selectedStation"
    :get-label="getStationLabel"
    @update-items="updateSuggestions"
    @input="stationChanged"
    :auto-select-one-item="false"
    :min-len="0"
    :wait="0"
    :input-attrs="autocompleteInputAttrs"
  />
</template>

<script>
import { isNull } from 'util';
import StationItem from './StationItem.vue';

import cloneObject from '../helpers/cloneObject';

export default {
  name: 'StationSelect',
  props: {
    stationID: {
      type: Number,
    },
    stationsList: {
      type: Array,
      required: true,
    },
    input_name: {
      type: String,
      required: true,
    },
    input_placeholder: {
      type: String,
      required: true,
    },
    input_title: {
      type: String,
      required: true,
    },
  },
  watch: {
    stationID() {
      const currentID = isNull(this.selectedStation)
        ? null
        : this.selectedStation.id;

      if (this.stationID !== currentID) {
        const value = this.stationsList.find(s => s.id === this.stationID);

        // utworzenie kopii powoduje reakcję Vue
        this.selectedStation = cloneObject(value === undefined ? null : value);
      }
    },
  },
  data() {
    return {
      component: StationItem,
      selectedStation: null, // obiekt
      visibleStations: [],
    };
  },
  computed: {
    autocompleteInputAttrs() {
      return {
        name: this.input_name,
        placeholder: this.input_placeholder,
        title: this.input_title,
        autocomplete: 'off',
      };
    },
  },
  methods: {
    stationChanged(station) {
      const value = station ? station.id : null;
      this.$emit('stationSelected', value);
    },
    getStationLabel(station) {
      return station ? station.displayName : '';
    },
    updateSuggestions(text) {
      if (text.length < 3) {
        this.visibleStations = [];
      } else {
        this.visibleStations = this.stationsList
          .filter(item => new RegExp(text.toLowerCase()).test(item.displayName.toLowerCase()))
          .sort((a, b) => b.popularity - a.popularity)
          .splice(0, 5); // do 5 wyników
      }
    },
  },
};
</script>

<style>
.v-autocomplete .v-autocomplete-input-group {
  width: 250px;
}

.v-autocomplete .v-autocomplete-input,
.v-autocomplete .v-autocomplete-list {
  border: none;
  border-radius: 4px;
}

.v-autocomplete .v-autocomplete-input {
  width: 100%;
  height: 50px;
  padding: 10px 20px;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.3);
  color: #444;
  border: 1px solid transparent;
}

.v-autocomplete.invalid .v-autocomplete-input {
  border: 1px solid #d60e0e;
}

.v-autocomplete .v-autocomplete-input::placeholder {
  color: #555;
}

.v-autocomplete .v-autocomplete-input:focus {
  border: 1px solid var(--color-hover);
}

/*.v-autocomplete
  .v-autocomplete-input-group.v-autocomplete-selected
  .v-autocomplete-input {
  color: var(--color-main);
  background-color: #f2fff2;
  }*/

.v-autocomplete .v-autocomplete-list {
  /*width: 100%;*/
  width: 250px;
  margin-top: 10px;
  overflow-y: auto;
  position: absolute;
  z-index: 1;
  box-shadow: 0 0 15px 10px rgba(0, 0, 0, 0.2);
}

.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item {
  padding: 10px 15px;
  cursor: pointer;
  background-color: #fff;
}

/* zdefiniowane w komponencie Item-u */
.v-autocomplete .v-autocomplete-list .v-autocomplete-list-item .station .name {
  display: inline-block;
  margin-left: 10px;
}

.v-autocomplete
  .v-autocomplete-list
  .v-autocomplete-list-item.v-autocomplete-item-active {
  background-color: var(--color-main);
  color: #fff;
}
</style>
